import regeneratorRuntime from "/app/node_modules/.pnpm/next@12.1.0_7f5822f691c4f776e4f56a7840bed181/node_modules/next/dist/compiled/regenerator-runtime/runtime.js";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/* eslint-disable no-console */ import '../styles/globals.scss';
import '../components/OldRender/components/ProductsService/index.scss';
import '../components/OldRender/editor-table.css';
import '@tencent/cms-design-component/lib/dist/style/main.css';
import '@tencent/tpm-product-intl/dist/TpmProductIntl.min.css';
import '@tencent/intl-design-ui/lib/scss/intl-ui.min.css';
import { StyleProvider } from '@ant-design/cssinjs';
import { DEFAULT_LANG } from 'common/constants';
import { isBrowser } from 'common/constants/config';
import { requestCdnData } from 'common-translation/request';
import { initI18nData } from 'common-translation/tools';
import App from 'next/app';
import Head from 'next/head';
import Script from 'next/script';
import CommonAppComp from 'portal-common/components/CommonApp';
import { PreviewTips } from 'portal-common/components/Tip';
import { getDomains } from 'portal-common/helpers/domainUtils';
import { getRealHostname } from 'portal-common/helpers/index';
import { getManifest, processI18nData } from 'portal-common/i18n-middleware';
import store from 'portal-common/store';
import { useRef } from 'react';
import { DomainContext } from '../components/OldRender/hooks/useDomainContext';
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
/**
 * 自定义App
 * @param {*} Component Component
 * @param {*} pageProps pageProps
 * @param {*} i18nData 多语言数据
 * @return {*}
 */ function CommonApp(param) {
    var Component = param.Component, pageProps = param.pageProps, i18nData = param.i18nData, domains = param.domains;
    // 客户端初始化 i18next（使用 ref 确保只初始化一次）
    var clientInitRef = useRef(false);
    if (isBrowser && i18nData && !clientInitRef.current) {
        initI18nData(i18nData);
        clientInitRef.current = true;
    }
    var lang = (i18nData === null || i18nData === void 0 ? void 0 : i18nData.lang) || DEFAULT_LANG; // 这里获取到的语言是和url路由中的一样。要求和cookie里的language也一样，header和footer的动态语言包才能正确显示；
    isBrowser && store.setLang(lang);
    var appData = {
        lang: lang,
        title: Component.title,
        keywords: Component.keywords,
        description: Component.description,
        showLayout: false
    };
    return(/*#__PURE__*/ _jsx(StyleProvider, {
        children: /*#__PURE__*/ _jsxs(CommonAppComp, _objectSpread({}, appData, {
            children: [
                /*#__PURE__*/ _jsx(Head, {
                    children: /*#__PURE__*/ _jsx("meta", {
                        name: "referrer",
                        content: "no-referrer-when-downgrade"
                    })
                }),
                /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(Script, {
                            children: "window.$qccomponent = {\n                  header: {\n                    isNeedFix: false,\n                  },\n                };\n              "
                        }),
                        /*#__PURE__*/ _jsx(Script, {
                            strategy: "afterInteractive",
                            id: "qccomponent-loader",
                            src: "/qccomponent/resources/loader.js?lang=".concat(lang)
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs(DomainContext.Provider, {
                    value: domains,
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            children: isBrowser && /*#__PURE__*/ _jsx(PreviewTips, {})
                        }),
                        /*#__PURE__*/ _jsx(Component, _objectSpread({}, pageProps, {
                            lang: lang
                        })),
                        /*#__PURE__*/ _jsx("script", {
                            src: 'https://t.captcha.qcloud.com/Captcha.js'
                        })
                    ]
                })
            ]
        }))
    }));
}
/**
 * 把host存下来，后续使用
 * @param req
 */ var handleRequestHosts = function(req) {
    var realHostname = getRealHostname(req, {
        withoutPort: false
    });
    // const realHostnameWithoutPort = getRealHostname(req,  { withoutPort: true });
    var domains = getDomains(realHostname);
    // const domainsWithoutPort = getDomains(realHostnameWithoutPort);
    // const cookieDomain = `.${domainsWithoutPort.QCLOUD_ROOT_HOST}`; // 如果后续需要用到cookieDomain，这个也要存下来
    return domains;
};
CommonApp.getInitialProps = (function() {
    var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee1(context) {
        var _ctx1, req, locale, domains, i18nDataRaw1, env, manifest, getCacheVersion, cacheVersion, cacheKey, ref, i18nData, appProps, allCacheKeys, oldVersionKeys;
        return regeneratorRuntime.wrap(function _callee$(_ctx2) {
            while(1)switch(_ctx2.prev = _ctx2.next){
                case 0:
                    _ctx1 = context.ctx, req = _ctx1.req, locale = _ctx1.locale;
                    store.setLang(locale);
                    domains = handleRequestHosts(req);
                    i18nDataRaw1 = (req === null || req === void 0 ? void 0 : req.$i18nData) || {
                        resources: _defineProperty({}, locale, {}),
                        ns: [],
                        lang: locale
                    };
                    env = process.env.ZONE_ENV || 'dev';
                    manifest = getManifest(env, [
                        'common',
                        'cloud-market'
                    ]);
                    getCacheVersion = function(i18nDataRaw) {
                        try {
                            var urls = [];
                            Object.values(i18nDataRaw.resources).forEach(function(nsData) {
                                Object.values(nsData).forEach(function(url) {
                                    if (typeof url === 'string' && url.includes('.js')) {
                                        urls.push(url);
                                    }
                                });
                            });
                            // 从 URL 中提取时间戳部分（如：3626-en-1767864896058.js）
                            var timestamps = urls.map(function(url) {
                                var match = url.match(/-(\d{13})\.js$/);
                                return match ? match[1] : '';
                            });
                            // 使用所有时间戳的组合作为版本标识
                            return timestamps.filter(Boolean).join('_') || 'v0';
                        } catch (error) {
                            console.error('[i18n-cache] Error extracting cache version:', error);
                            return Date.now().toString(); // 降级：使用当前时间戳
                        }
                    };
                    cacheVersion = getCacheVersion(i18nDataRaw1);
                    cacheKey = "RENDER_I18N_".concat(locale, "_").concat(cacheVersion);
                    console.log("[i18n-cache] Checking cache for key: ".concat(cacheKey));
                    _ctx2.t0 = _slicedToArray;
                    _ctx2.next = 13;
                    return Promise.all([
                        !store.getStore(cacheKey) ? _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
                            var startTime, data, duration;
                            return regeneratorRuntime.wrap(function _callee$(_ctx) {
                                while(1)switch(_ctx.prev = _ctx.next){
                                    case 0:
                                        console.log("[i18n-cache] ❌ Cache MISS for ".concat(locale, ", version: ").concat(cacheVersion));
                                        startTime = Date.now();
                                        _ctx.next = 4;
                                        return processI18nData({
                                            i18nDataRaw: i18nDataRaw1,
                                            manifest: manifest,
                                            requestCdnData: requestCdnData
                                        });
                                    case 4:
                                        data = _ctx.sent;
                                        duration = Date.now() - startTime;
                                        console.log("[i18n-cache] ✅ CDN fetch completed in ".concat(duration, "ms for ").concat(locale));
                                        console.log("[i18n-cache] Data size: ".concat(JSON.stringify(data).length, " bytes"));
                                        return _ctx.abrupt("return", data);
                                    case 9:
                                    case "end":
                                        return _ctx.stop();
                                }
                            }, _callee);
                        }))() : _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
                            var cachedData;
                            return regeneratorRuntime.wrap(function _callee$(_ctx) {
                                while(1)switch(_ctx.prev = _ctx.next){
                                    case 0:
                                        console.log("[i18n-cache] ✅ Cache HIT for ".concat(locale, ", version: ").concat(cacheVersion));
                                        cachedData = store.getStore(cacheKey);
                                        console.log("[i18n-cache] Cached data size: ".concat(JSON.stringify(cachedData).length, " bytes"));
                                        return _ctx.abrupt("return", cachedData);
                                    case 4:
                                    case "end":
                                        return _ctx.stop();
                                }
                            }, _callee);
                        }))(),
                        App.getInitialProps(context), 
                    ]);
                case 13:
                    _ctx2.t1 = _ctx2.sent;
                    ref = (0, _ctx2.t0)(_ctx2.t1, 2);
                    i18nData = ref[0];
                    appProps = ref[1];
                    // 🔑 如果缓存不存在，写入缓存
                    if (!store.getStore(cacheKey)) {
                        console.log("[i18n-cache] 💾 Storing data to cache: ".concat(cacheKey));
                        store.setStore(cacheKey, i18nData);
                        allCacheKeys = Object.keys(store).filter(function(k) {
                            return k.startsWith('RENDER_I18N_');
                        });
                        oldVersionKeys = allCacheKeys.filter(function(k) {
                            return k.startsWith("RENDER_I18N_".concat(locale, "_")) && k !== cacheKey;
                        });
                        oldVersionKeys.forEach(function(oldKey) {
                            delete store[oldKey];
                            console.log("[i18n-cache] 🗑️ Removed old cache: ".concat(oldKey));
                        });
                        console.log("[i18n-cache] Total cached versions: ".concat(allCacheKeys.length - oldVersionKeys.length + 1));
                    }
                    if (!("object" === 'undefined')) {
                        _ctx2.next = 21;
                        break;
                    }
                    _ctx2.next = 21;
                    return initI18nData(i18nData);
                case 21:
                    return _ctx2.abrupt("return", _objectSpread({
                        i18nData: i18nData
                    }, appProps, {
                        domains: domains
                    }));
                case 22:
                case "end":
                    return _ctx2.stop();
            }
        }, _callee1);
    }));
    return function(context) {
        return _ref.apply(this, arguments);
    };
})();
export default CommonApp;
